import { useContext,useEffect } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext} from "../context/Authcontext";



const ProtectedRoute = ({ children }) => {
  const { authStatus } = useContext(AuthContext)

  //console.log('authstatus es: ', authStatus)


  return authStatus === "authorized" ? children : <Navigate to="/login" />
}

export default ProtectedRoute